<script setup lang="ts">
import ProductDetail from '../../components/ProductsComponents/Detail/ProductDetail.vue'
</script>

<template>
    <ProductDetail />
</template>
